import { useMemo } from 'react';
import { getConfig } from '../../../config';
import { AdminApiDomain, getAdminApiUrl } from '../../../config/ApiRouting';
import { ProductGroupClient } from '../../../infrastructure/ProductGroupClient';

export const useProductGroup = (): ProductGroupClient => {
  const config = getConfig();
  const productApiUrl = getAdminApiUrl(AdminApiDomain.PRODUCT);
  return useMemo(() => new ProductGroupClient(productApiUrl, config.apiKey), [productApiUrl, config.apiKey]);
};
